export default "__VITE_ASSET__fIHy3pmp__"